import { Component, Prop, Watch, h } from '@stencil/core';
import { store } from '../../redux/store';
import { Unsubscribe } from '@stencil/redux';
import { RootState } from '../../redux/reducers';
import { requireInit } from '../../redux/actions';
import { setDefaultOptions } from 'date-fns';
import { localeToFnsLocale } from '../../utils/trans';
import { System } from '../../redux/types';
import { setupLangObserver } from '../../utils/langObserver';
import { getLocaleWithCountryCode, LocaleCode } from '../../utils/language';

@Component({
  tag: 'rtr-ready-wrapper',
  shadow: true,
  styleUrl: './style.sass',
})
export class RtrReadyWrapper {
  @Prop({ mutable: true }) locale: string;
  @Prop({ mutable: true }) appLoaded: boolean;
  @Prop({ mutable: true }) system: System; // need to be a prop to detect changes for children
  @Prop({ mutable: true }) renderOnReady: () => void;

  // Static property to track if the language observer has been initialized
  private static langObserverInitialized = false;

  requireInit!: typeof requireInit;
  unsubscribe!: Unsubscribe;

  componentWillLoad() {
    store.mapDispatchToProps(this, {
      requireInit,
    });

    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        appLoaded: state.app.appLoaded,
        locale: state.app.locale,
        system: state.system,
      };
    });
  }

  @Watch('locale')
  localeHasChanged(newLocale: LocaleCode, oldLocale: LocaleCode) {
    if (!!newLocale && getLocaleWithCountryCode(newLocale) !== getLocaleWithCountryCode(oldLocale)) {
      const fnsLocale = localeToFnsLocale(this.locale);
      setDefaultOptions({ locale: fnsLocale });
    }
  }

  componentDidLoad() {
    this.requireInit();

    // Set up the language observer to watch for HTML lang attribute changes
    if (!RtrReadyWrapper.langObserverInitialized) {
      setupLangObserver();
      RtrReadyWrapper.langObserverInitialized = true;
    }
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  render() {
    if (!this.appLoaded || !this.system.systemLoaded || !this.locale) {
      return <div class="RtrReadyWrapper" />;
    }

    return <div class="RtrReadyWrapper">{this.renderOnReady()}</div>;
  }
}
